import React, { FC, useEffect, useState } from 'react';
import './style.scss';

interface Props {}
const CreditGrid: FC<Props> = () => {
  return (
    <div className="_no_result_table">
      <div className="_label">입력된 값이 없습니다.</div>
    </div>
  );
};

export default CreditGrid;
